import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type EmbeddedSessionState = {
  sessionToken?: string;
};

const initialState: EmbeddedSessionState = {
  sessionToken: undefined,
};

const slice = createSlice({
  name: 'embeddedSession',
  initialState,
  reducers: {
    setEmbeddedSessionToken: (state, action: PayloadAction<string>) => ({
      ...state,
      sessionToken: action.payload,
    }),
  },
});

export const embeddedSessionReducer = slice.reducer;
export const { setEmbeddedSessionToken } = slice.actions;
